import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { ICmsPageDecorator } from '../../../page/icms-page.decorator';
import { CMS_BLOG_CATEGORY_CONFIG } from '../cms-blog-category.config';

@Component({
    selector: 'cms-blog-category-view',
    templateUrl: './cms-blog-category-view.component.html',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsPageType(CMS_BLOG_CATEGORY_CONFIG)
export class CmsBlogCategoryViewComponent extends UiComponent {
    @Input({ required: true })
    model!: ICmsPageDecorator<IPageDataV3>;
}
